<template>
  <div class="HistoryDetailsComponent">
    <p v-if="revisionId == ''">{{ lang.infotext_1 }}</p>
    <div v-if="revisionId != ''">

      <!-- <p v-if="comments.length == 0">{{ lang.infotext_3 }}</p> -->

      <div class="list-details" v-if="comments.length > 0">
        <p class="info-text">{{ lang.infotext_2 }}:</p>
        <b-list-group>


          <div v-for="comment in comments" :key="comment.id">
            <b-list-group-item>
              <p >{{ longDateToShort(comment.creationDate) }} |  {{ comment.login }} | 
                <span v-if="comment.type == 'comment'" class="positive-comment">{{comment.status}}</span>
                <span v-if="comment.type == 'reason'" class="negative-comment">{{ lang.label_Reason }}</span>
                <!-- <span v-if="comment.type == 'comment'">{{ lang.label_Comment }}</span> -->
                <span v-if="comment.type == 'transfer'" class="normal-comment">{{ lang.label_Transfer }}</span>
                <span v-if="comment.type == 'assign'" class="normal-comment">{{ lang.label_Assign }}</span>
                <span v-if="comment.type == 'unassign'" class="normal-comment">{{ lang.label_Unassign }}</span>
                <span v-if="comment.type == 'move'" class="normal-comment">{{ lang.label_Move }}</span>
              </p>
              <span v-if="comment.comment != ''">
                <p v-if="comment.type == 'comment' && comment.status != 'Requested'"  class="task-reason-text">{{ comment.comment }}</p>
                <p v-if="comment.type == 'reason'"  class="task-reason-text">{{ comment.comment }}</p>
                <p v-if="comment.type == 'transfer'"  class="task-reason-text">{{ comment.comment }}</p>
                <p v-if="comment.type == 'assign'" class="task-reason-text">{{ prepareAssing(comment.comment) }}</p>
                <p v-if="comment.type == 'unassign'" class="task-reason-text">{{ prepareAssing(comment.comment) }}</p>
                <p v-if="comment.type == 'move'" class="task-reason-text">{{ comment.comment }}</p>
              </span>
                
            </b-list-group-item>

          </div>


        </b-list-group>
      </div>


    </div>


  </div>
</template>

<script>

import * as Tools from '@/Tools/Tools';


export default {
  name: "HistoryDetailsComponent",
  props: {
    lang: Object,
    parent: String
  },
  components: {

      
  },
  data() {
    return {
        
      comments: [],
        
    }
  },
  computed: {
    name() {
      return   "HistoryDetailsComponent" + this.parent
    },
    revisionId() {
      let revisionId = "--";

      if (this.$route.path == "/PartManager/PartDetails" || this.$route.path == "/LibraryManager/LibraryDetails") {
          
        const tab = this.$store.getters.selectedRevisionRow
        let rev = 0;
        let revId = "";
        for (let i = 0, lei = tab.length; i < lei; i++) {

          if (tab[i].revision > rev) {
              rev = tab[i].revision;
              revId = tab[i].revisionId;
          }

        }
        revisionId = revId;
      }
      if (this.$route.path == "/PartManager/PartTable" || this.$route.path == "/LibraryManager/LibraryTable") {

        if (this.$store.getters.selectedRows.length != 0) {
            
          revisionId = this.$store.getters.selectedRows[0].col___revisionId.revisionId;
                        
        }
      }
      
      

    return revisionId;

    },
    lastRevisionHistory() {

      let tab = this.$store.getters.revisionHistory;
      let obj = tab[0];
      for (let i = 0, lei = tab.length; i < lei; i++) {

          if (tab[i].revision > obj.revision) {
              obj = tab[i];
          }
      }

      return obj;
    },
    selectedLastRevisionRow() {
      if (this.parent == "table") {
          return true;
      }
      if (this.$store.getters.selectedRevisionRow.length == 0) {
          return false;
      }
      return this.$store.getters.selectedRevisionRow[0].revisionId == this.lastRevisionHistory.id;
    },
    
    reloadedAfterActionComplex() {
      return this.$store.getters.reloadedAfterActionComplex;
    },
      
  },
  created() {


    this.getComments();


  },
  watch: {
    revisionId: function () {


      this.getComments();


    },
      
    reloadedAfterActionComplex: {
      handler: function (newValue) {
          
        for (let el in newValue) {
            
          if (newValue[el].name == this.name) {

            if (newValue[el].status == true) {

              this.getComments(this);

              newValue[el].status = false;

              this.$store.dispatch("reloadAfterActionComplex", newValue[el]);
            }
          }
        }
      },
      deep: true

    },
  },
  
  methods: {
    prepareAssing(str) {
        
        let res = "";
        let temp = str.split(";");
        return temp[0] + " | " + temp[1] + " | " + temp[2]

    },
    longDateToShort(date) {
        return Tools.longDateToShort(date);
    },
    getComments() {

      let vue = this;

      const obj = {
        revisionId: this.revisionId
      }

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_getHistoryComments", obj)
        .then((result) => {

            console.log(result)
            if (result.status == "OK") {

              vue.comments = result.data
              for (let i = 0, lei = vue.comments.length; i < lei; i++) {

                if (vue.comments[i].reason == null) {
                    vue.comments[i].reason = "";
                }
                if (vue.comments[i].comment == null) {
                    vue.comments[i].comment = "";
                }
                  
              }

                
            }


        })
    },
      
      

  }


}
</script>
<style lang="scss">
 @import "./../../scss/_custom.scss";
  .HistoryDetailsComponent {
    .task-buttons {
        margin-left: 50px;

    }

    .task-reason-text {
        margin-left: 20px;
    }

    .list-group-item {
        margin-top: 5px;
    }
    .normal-comment{
        color: $yellow;
    }
    .positive-comment{
        color: $green;
    }
    .negative-comment{
        color: $orange;
    }
    
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/HistoryDetailsComponent.vue